import React from "react";
import HuynhPic from "../images/BaoHuynhPortrait.jpg";
import LonePic from "../images/UsmanLonePortrait.jpg";
import MalasPic from "../images/MALAS.png";
import RayPic from "../images/default_male.jpg"
import MoePic from "../images/MOE.png";
import PalakPic from "../images/default_female.jpg"

let srcLink;

const PicMD = ({ doctor }) => {
  if (doctor === "Huynh") srcLink = HuynhPic;
  if (doctor === "Malas") srcLink = MalasPic;
  if (doctor === "Lone") srcLink = LonePic;
  if (doctor === "Ray") srcLink = RayPic;
  if (doctor === "Moe") srcLink = MoePic;
  if (doctor === "Palak") srcLink = PalakPic;

  return (
    <div>
      <img
        src={srcLink}
        style={{
          float: "left",
          width: "106px",
          height: "122px",
          aspectRatio: "106 / 122",
          marginRight: "15px",
        }}
        className="ui image"
      />
    </div>
  );
};

export default PicMD;
